/**
 * Lab-only state: the packets the fake socket has "sent" and the currently
 * applied fixture. Its own store so nothing in the real screen imports it.
 */
import {create} from 'zustand';

import {setSocketProvider} from '@/Store/liveGameStore';

export type SentPacket = {type: string; packet: any; at: number};

export type LabStore = {
  sent: SentPacket[];
  fixture: string;
  record: (type: string, packet: any) => void;
  clear: () => void;
  setFixture: (fixture: string) => void;
};

export const useLabStore = create<LabStore>(set => ({
  sent: [],
  fixture: 'liveMyMove',
  record: (type, packet) =>
    set(s => ({
      sent: [{type, packet, at: Date.now()}, ...s.sent].slice(0, 60),
    })),
  clear: () => set({sent: []}),
  setFixture: fixture => set({fixture}),
}));

/**
 * The fake socket. `cc_ws_client`'s only surface the actions use is
 * `send_msg(type, packet)` (see `createActions.send`), so this is the whole
 * contract: every outgoing packet lands in the panel instead of the wire.
 */
export const fakeSocket = {
  username: '',
  connected: true,
  send_msg(type: string, packet: any) {
    useLabStore.getState().record(type, packet);
  },
  registerMessageType() {},
  registerMessageHandler() {},
  on() {},
  off() {},
};

export const installFakeSocket = (): void => {
  setSocketProvider(() => fakeSocket);
};

export default useLabStore;
